import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
const apiClient2 = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error: '',
  error400: false,
  successFlag: false,
  token: '',
  clientComputers: [],
  allClientComputers: [],
  totalPages: 0,
  totalRecords: 0,
  clientComputer: null,
  errorStatus: null,
  validate: null,
};
const getters = {
  getApiLoad_14: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_ClientComputers(state, clientComputers) {
    state.clientComputers = clientComputers.items;
    state.totalPages = clientComputers.totalPages;
    state.totalRecords = clientComputers?.totalRecords ?? 0;
  },
  SET_AllClientComputers(state, clientComputers) {
    state.allClientComputers = clientComputers;
  },
  SET_ClientComputer(state, clientComputer) {
    state.clientComputer = clientComputer;
  },
  SET_Validate(state, validate) {
    state.validate = validate;
  },
};
const actions = {
  errorClientComputer({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllClientComputers({ commit, dispatch, rootState }) {
    return apiClient
      .get('/ClientComputers/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllClientComputers', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClientComputer', error);
      });
  },
  getClientComputersWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, extensionId, zoneId, cityId, uniqueId, title },
  ) {
    var url = '/ClientComputers/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (extensionId) {
      url += '&ExtensionId=' + extensionId;
    }
    if (zoneId) {
      url += '&zoneId=' + zoneId;
    }
    if (cityId) {
      url += '&cityId=' + cityId;
    }
    if (uniqueId) {
      url += '&uniqueId=' + uniqueId;
    }
    if (title) {
      url += '&title=' + title;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_ClientComputers', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClientComputer', error);
      });
  },
  addClientComputer({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/ClientComputers', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClientComputer', error);
      });
  },
  getClientComputer({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/ClientComputers/ById?clientComputerId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_ClientComputer', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClientComputer', error);
      });
  },
  editClientComputer({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/ClientComputers/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClientComputer', error);
      });
  },
  deleteClientComputer({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/ClientComputers/Remove?clientComputerId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClientComputer', error);
      });
  },
  addClientComputerRequest({ commit, dispatch }, data) {
    return apiClient2
      .post('/ClientComputers/RequestAdd', data)
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClientComputer', error);
      });
  },
  validateClientComputer({ commit, dispatch }, id) {
    return apiClient2
      .get('/ClientComputers/Validate?uniqueId=' + id)
      .then((response) => {
        commit('SET_Validate', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClientComputer', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
